import React, { Component } from 'react'
import { Link, useHistory } from 'react-router-dom';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { ThemeProvider } from 'styled-components';
import moment from 'moment';


const tipos = [
    {label:'Lavar/Passar'            , value:'1'},
    {label:'Lavar'                  , value:'2'},
    {label:'Passar'                 , value:'3'},
]

class lavar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            listarFuncionario: [],
            listarFuncionarioPassar:[],
            funcionario:'',
            listarCliente: [],
            cliente:'',
            producao:'',
            pedidosEmLavagem: [],
            pedidosSaparado: new Object(),
            pedidosItensSaparado: new Object(),
            itens: [],
            pessoaPassar: '',
            dataPassar: '',
            isApenasLavagem: false,
            isLoading: false
        } 
        this.buscar = this.buscar.bind(this) 
        this.cheked = this.cheked.bind(this)   
        this.uncheked = this.uncheked.bind(this)
        this.itemcheked = this.itemcheked.bind(this)
        this.itemuncheked = this.itemuncheked.bind(this)
        this.concluir = this.concluir.bind(this)
        this.finalizar = this.finalizar.bind(this)
    }

    async Loading( isLoading) {
        this.setState({ isLoading: isLoading});
    }

    async componentDidMount() {

        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo');
        
        this.Loading(true);

        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        }).catch((e) => {
            this.Loading(false);
        });       

        const empresaLavar        = permissoes.data.filter(function(value){ return value.idmenu  == 7  })
        if( !empresaLavar.length && empresaLavar[0].permissao.indexOf('VER') < 0 ) return this.props.history.push('/index');

        const listarPessoas = await api.get('/api/pessoa', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 

        const listarFuncionario = [{value: 0, label:'Todos' }];
        const listarCliente = [{value: 0, label:'Todos' }];
        const listarFuncionarioPassar = []
        listarPessoas.data.forEach(element => {
            if( element.tipo != 1 ) {
                listarFuncionario.push({value: element.id, label:element.razao });           
                listarFuncionarioPassar.push({value: element.id, label:element.razao }); 
            } else {
                listarCliente.push({value: element.id, label:element.razao }); 
            }
        });
        
        this.Loading(false);

        this.setState({
            listarFuncionario: listarFuncionario,
            funcionario: '',
            listarCliente: listarCliente,
            cliente:'',
            producao:'',
            pedidosEmLavagem:[],
            listarFuncionarioPassar:listarFuncionarioPassar,
            pedidosSaparado: new Object(),
            pedidosItensSaparado: new Object(),
            isApenasLavagem: true,
        })      
        
    }

    buscar = async() =>  {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo');
        
        this.Loading(true);

       
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        }).catch((e) => {
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        });       

        const empresaSeparacao        = permissoes.data.filter(function(value){ return value.idmenu  == 7  })
        if( empresaSeparacao.length > 0 && empresaSeparacao[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.')

        const body = {
            responsavel: this.state.funcionario,
            cliente: this.state.cliente,
            entrega: this.state.producao
        }

        const listarLavagem= await api.post('api/lavar', body, {
            headers: {
                'x-access-token':token,
            }
        })   

        this.Loading(false);

        this.setState({
            pedidosEmLavagem:listarLavagem.data,
            pedidosSaparado: new Object(),
            pedidosItensSaparado: new Object(),
            itens: [],
            isApenasLavagem: true,
        })   
    }

    cheked = async( id ) =>  {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo');
        
        this.Loading(true);

        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        }).catch((e) => {
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        });       

        const empresaSeparacao        = permissoes.data.filter(function(value){ return value.idmenu  == 7  })
        if( empresaSeparacao.length > 0 && empresaSeparacao[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.')

        const itens = this.state.pedidosSaparado ? this.state.pedidosSaparado : new Object()
        const pedidosItensSaparado = this.state.pedidosItensSaparado ? this.state.pedidosItensSaparado : new Object();

        const listarItens = this.state.itens ? this.state.itens : []
        let apenasLavagem = false
        if( !itens[id] ){

            const listarItensLavagem= await api.get(`api/lavar/${id}`, {
                headers: {
                    'x-access-token':token,
                }
            }) 
            
            itens[id] = listarItensLavagem.data
            listarItensLavagem.data.forEach(item => {
                
                if( !pedidosItensSaparado[item.id] ) {
                    pedidosItensSaparado[item.id] = item.id
                }

                apenasLavagem = item.tipo_item != 1 ? true : apenasLavagem
                listarItens.push(item)    
            });
        }

        this.Loading(false);

        this.setState({
            pedidosSaparado: itens,
            itens: listarItens,
            isApenasLavagem: apenasLavagem
        })   
    }

    uncheked = async( id ) =>  {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo');
        
        this.Loading(true);

        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        }).catch((e) => {
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        });       

        const empresaSeparacao        = permissoes.data.filter(function(value){ return value.idmenu  == 7  })
        if( empresaSeparacao.length > 0 && empresaSeparacao[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.')

        const itens = this.state.pedidosSaparado ? this.state.pedidosSaparado : new Object()
        const itensNovo = new Object()
        const listarItens =  []
 
        for (const key in itens) {
            if (Object.hasOwnProperty.call(itens, key)) {
                if(id != key) {
                    itensNovo[key] = itens[key]

                    itensNovo[key].forEach(item => {
                        listarItens.push(item)    
                    });
                }
                
            }
        }
        this.Loading(false);


        this.setState({
            pedidosSaparado: itensNovo,
            itens: listarItens
        })   
    }

    itemcheked = async( id ) =>  {
        const pedidosItensSaparado = this.state.pedidosItensSaparado ? this.state.pedidosItensSaparado : new Object();
        if( !pedidosItensSaparado[id] ) {
            pedidosItensSaparado[id] = id
        }

        this.setState({ pedidosItensSaparado: pedidosItensSaparado});
    }

    itemuncheked = async( id ) =>  {
        const pedidosItensSaparado = this.state.pedidosItensSaparado ? this.state.pedidosItensSaparado : new Object();
        const pedidosItensSaparadoNovo = new Object()
        for (const key in pedidosItensSaparado) {
            if (Object.hasOwnProperty.call(pedidosItensSaparado, key)) {
                if(key != id ) {
                    pedidosItensSaparadoNovo[key] = pedidosItensSaparado[key]
                }              
                
            }
        }
        

        this.setState({ pedidosItensSaparado: pedidosItensSaparadoNovo});
    }

    concluir = async() =>  {
        const pedidos = this.state.pedidosEmLavagem.length > 0 ? this.state.pedidosEmLavagem : [];
        const itens   = this.state.itens.length > 0 ? this.state.itens : [];

        let isApenasLavagem = true;

        itens.forEach(item => {                    
            if( this.state.pedidosItensSaparado[item.id]) {
                isApenasLavagem = item.tipo_item != 2 ? false : isApenasLavagem
            }
        });

        this.setState({
            isApenasLavagem: isApenasLavagem,
        })   
    }

    finalizar = async() =>  {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo');
        
        this.Loading(true);

        const pedidos = this.state.pedidosEmLavagem.length > 0 ? this.state.pedidosEmLavagem : [];
        const itens   = this.state.itens.length > 0 ? this.state.itens : [];

        const pedidosSeparados = [];
        const itensSeparados = [];

        pedidos.forEach(pedido => {
            if(this.state.pedidosSaparado[pedido.id]) {
                pedido.funcionario = this.state.pessoaPassar
                pedido.previsao = this.state.dataPassar
                pedidosSeparados.push(pedido)
                const itensSelecionados = itens.filter(function(value){ return value.producao  == pedido.id })
                itensSelecionados.forEach(item => {                    
                    if( this.state.pedidosItensSaparado[item.id]) {
                        itensSeparados.push(item)  
                    }
                });
            }
        });
        const data = {
            producao: pedidosSeparados, 
            itens: itensSeparados
        }

        await api.post('/api/lavar/concluir', data, {
            headers: {
                'x-access-token':token,
            }
        })
        .catch((e) => {
            this.Loading(false);
            toast.error(e)
        });

        const listarPessoas = await api.get('/api/pessoa', {
            headers: {
                'x-access-token':token,
            }
        }).catch(e =>{
            this.Loading(false);
            toast.error('Ops! Error:' + e)
        }) 

        const listarFuncionario = [{value: 0, label:'Todos' }];
        const listarCliente = [{value: 0, label:'Todos' }];
        const listarFuncionarioPassar = []
        listarPessoas.data.forEach(element => {
            if( element.tipo != 1 ) {
                listarFuncionario.push({value: element.id, label:element.razao });           
                listarFuncionarioPassar.push({value: element.id, label:element.razao }); 
            } else {
                listarCliente.push({value: element.id, label:element.razao }); 
            }
        });
        
        this.Loading(false);
        toast.success("Produção Finalizada com sucesso!")
        this.setState({
            listarFuncionario: listarFuncionario,
            funcionario: '',
            listarCliente: listarCliente,
            cliente:'',
            producao:'',
            pedidosEmLavagem:[],
            listarFuncionarioPassar:listarFuncionarioPassar,
            pedidosSaparado: new Object(),
            pedidosItensSaparado: new Object(),
            isApenasLavagem: true,
            itens: [],
        })      

    }

    render() {
        return ( 
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Processo de Lavagem</h3>

                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
                                        <i class="fas fa-minus"></i>
                                    </button>
                                    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">                                    
                                        <div class="row">  
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <label>Responsável</label>
                                                    <Select
                                                        id="responsvael"
                                                        placeholder="Selecione" 
                                                        isSearchable="true"
                                                        isOptionSelected 
                                                        options={this.state.listarFuncionario}  
                                                        onChange={ e => this.setState({funcionario: e.value}) }    
                                                                                                                             
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <label>Cliente:</label>
                                                    <Select
                                                        id="tipo"
                                                        placeholder="Selecione" 
                                                        isSearchable="true"
                                                        isOptionSelected    
                                                        options={this.state.listarCliente}  
                                                        onChange={ e => this.setState({cliente: e.value}) }    
                                                                                            
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-sm-3">

                                                <div class="form-group">
                                                    <label>Data Produção</label>
                                                    <input type="date" 
                                                        id='producao' 
                                                        name='producao' 
                                                        class="form-control" 
                                                        placeholder="Informe data de producao" 
                                                        value={ this.state.producao } 
                                                        onChange={ e => this.setState({ producao: e.target.value})} 
                                                    />
                                                </div>    
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <label>Ação:</label>                                            
                                                    <button type="button" class="btn btn-block bg-gradient-primary" onClick={ () => this.buscar() }>Buscar</button>
                                                </div>
                                            </div>
                                            <br/><br/><br/><br/>
                                            <table class="table table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Número</th>
                                                        <th>Status</th>
                                                        <th>Data</th>
                                                        <th>Responsável</th>
                                                        <th>Data Produção</th>
                                                        <th>Qts Pedidos</th>
                                                        <th>Qts Itens</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.pedidosEmLavagem.map( (pedido) => 
                                                            <tr key={pedido.id}>    
                                                                <td>
                                                                    {
                                                                        !this.state.pedidosSaparado[pedido.id] ?
                                                                        <input type="checkbox" onClick={ () => this.cheked(pedido.id)}/> :
                                                                        <input type="checkbox" onClick={ () => this.uncheked(pedido.id)} checked/>
                                                                    }
                                                                </td>
                                                                <td>
                                                                    { pedido.numero }
                                                                </td>
                                                                <td>
                                                                    { pedido.status == 1 ? 'Pendente' : 'Em Andamento' }
                                                                </td>
                                                                <td>
                                                                    { pedido.emissao ? moment(pedido.emissao).format('DD/MM/yy') : ''}
                                                                </td>
                                                                <td>
                                                                    { pedido.responsavel }
                                                                </td>
                                                                <td>
                                                                    { pedido.previsao ? moment(pedido.previsao).format('DD/MM/yy') : ''}
                                                                </td>
                                                                <td>
                                                                    { pedido.pedidos }
                                                                </td>
                                                                <td>
                                                                    { pedido.itens }
                                                                </td>                                                                
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                                
                                            </table>
                                        </div>
                                    </div>
                                    
                                </div>   
                                <div class="card-header">
                                    <h2 class="card-title">Itens Em Produção</h2>

                                    
                                </div>                           
                                <div class="row">
                                    <div class="col-12">
                                        <table class="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Status</th>
                                                    <th>Número OS</th>
                                                    <th>Cliente</th>
                                                    <th>Serviço</th>
                                                    <th>Qtd</th>
                                                    <th>Tipo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.itens.map( (item) => 
                                                        <tr key={item.id}>    
                                                            <td>
                                                                {
                                                                    !this.state.pedidosItensSaparado[item.id] ?
                                                                    <input type="checkbox" onClick={ () => this.itemcheked(item.id)} disabled/> :
                                                                    <input type="checkbox" onClick={ () => this.itemuncheked(item.id)} checked disabled/>
                                                                }
                                                            </td>
                                                            <td>
                                                                { !this.state.pedidosItensSaparado[item.id] ? 'Pendente' : 'Concluído' }
                                                            </td>
                                                            <td>
                                                                { item.numero }
                                                            </td>
                                                            <td>
                                                                { item.cliente }
                                                            </td>
                                                            <td>
                                                                { item.servico }
                                                            </td>
                                                            <td>
                                                                { item.quantidade }
                                                            </td>
                                                            <td>
                                                                { item.tipo_item == 1 ? 'Lavar/Passar' :  'Somente Lavar' }
                                                            </td>                                                           
                                                        </tr>                                                        
                                                    )
                                                }
                                               
                                            </tbody>
                                        </table> 
                                        <div class="modal-footer justify-content-between">
                                            <button type="button" class="btn btn-success" data-toggle="modal" data-target={ this.state.itens.length > 0 ? "#modal-itens-lavagem" : "#"} disabled={this.state.itens.length > 0 ? false : true} onClick={ e => this.concluir() }>Finalizar Lavagem</button>                                          
                                        </div>                                   
                                    </div>                                  
                                </div>

                                <div class="modal fade" id="modal-itens-lavagem">
                                    <div class="modal-dialog modal-lg">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h4 class="modal-title">Finalizar Produção (Lavagem)</h4>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                           
                                                {
                                                    !this.state.isApenasLavagem ?
                                                    <div class="modal-body">
                                                        <div class="form-group">
                                                            <label>Responsável</label>
                                                            <Select
                                                                id="responsvael"
                                                                placeholder="Selecione" 
                                                                isSearchable="true"
                                                                isOptionSelected 
                                                                options={this.state.listarFuncionarioPassar}  
                                                                onChange={ e => this.setState({pessoaPassar: e.value}) }    
                                                                                                                                    
                                                            />
                                                        </div>
                                                        <div class="form-group">
                                                            <label>Data Produção</label>
                                                            <input type="date" 
                                                                id='producao' 
                                                                name='producao' 
                                                                class="form-control" 
                                                                placeholder="Informe data de producao" 
                                                                value={ this.state.dataPassar } 
                                                                onChange={ e => this.setState({ dataPassar: e.target.value})} 
                                                            />
                                                        </div>
                                                    </div> : 
                                                     <div class="modal-body">
                                                         Deseja realmente finalizar?
                                                     </div>
                                                }
                                                
                                           
                                            <div class="modal-footer justify-content-between">
                                                <button type="button" class="btn btn-success"  data-dismiss="modal" onClick={ () => this.finalizar() }>Finalizar</button> 
                                                <button type="button" class="btn btn-primary" data-dismiss="modal">Fechar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            { 
                                this.state.isLoading ?
                                <div class="overlay d-flex justify-content-center align-items-center">
                                    <i class="fas fa-2x fa-sync fa-spin"></i>
                                </div> : ''
                            }
                        </div>
                    </section>
                </div>
            </div> 
        );
    }

}


export default lavar;